import {
  isPossiblePhoneNumber,
  isValidPhoneNumber,
} from 'react-phone-number-input';

export const patterns: Record<string, string> = {
  name: '^[a-zA-ZÀ-ÿ- ]+$',
  text: '^[a-zA-ZÀ-ÿ0-9- ]+$',
  text_noaccent: '^[a-zA-Z0-9- ]+$',
  alpha_accent: '^[a-zA-ZÀ-ÿ-]+$',
  alpha_noaccent: '^[a-zA-Z-]+$',
  alphanum_accent: '^[a-zA-ZÀ-ÿ0-9-]+$',
  alphanum_noaccent: '^[a-zA-Z0-9-]+$',
  hidden: '^[a-zA-Z0-9-]+$',
  number: '^[0-9]+$',
  email: '^([A-Za-z0-9\\._+-]+)(@[A-Za-z0-9-]+(\\.{1})([A-Za-z0-9]{2,10}))$',
};

// Array des numéros interdits demandés par Bertrand
export const forbiddenNumbers: string[] = [
  '+33 0 00 00 00 00',
  '+33 1 11 11 11 11',
  '+33 2 22 22 22 22',
  '+33 3 33 33 33 33',
  '+33 4 44 44 44 44',
  '+33 5 55 55 55 55',
  '+33 6 66 66 66 66',
  '+33 7 77 77 77 77',
  '+33 8 88 88 88 88',
  '+33 9 99 99 99 99',
  '+33 6 06 06 06 06',
  '+33 7 07 07 07 07',
  '+33 1 01 01 01 01',
  '+33 2 02 02 02 02',
  '+33 3 03 03 03 03',
  '+33 4 04 04 04 04',
  '+33 5 05 05 05 05',
  '+33 6 06 06 06 06',
  '+33 7 07 07 07 07',
  '+33 8 08 08 08 08',
  '+33 9 09 09 09 09',
  '+33 6 12 34 56 78',
  '+33 7 12 34 56 78',
  '+33 1 23 45 67 89',
];

const isCorrectPhoneNumber = (value: string): boolean => {
  const pattern1 = new RegExp(/^\+[0-9]{1,3}[1]{1,}$/);
  const pattern2 = new RegExp(/^\+[0-9]{1,3}[2]{1,}$/);
  const pattern3 = new RegExp(/^\+[0-9]{1,3}[3]{1,}$/);
  const pattern4 = new RegExp(/^\+[0-9]{1,3}[4]{1,}$/);
  const pattern5 = new RegExp(/^\+[0-9]{1,3}[5]{1,}$/);
  const pattern6 = new RegExp(/^\+[0-9]{1,3}[6]{1,}$/);
  const pattern7 = new RegExp(/^\+[0-9]{1,3}[7]{1,}$/);
  const pattern8 = new RegExp(/^\+[0-9]{1,3}[8]{1,}$/);
  const pattern9 = new RegExp(/^\+[0-9]{1,3}[9]{1,}$/);
  const pattern0 = new RegExp(/^\+[0-9]{1,3}[0]{1,}$/);

  const normalized = value.replace(/\s/g, '');
  return !(
    pattern1.test(normalized) ||
    pattern2.test(normalized) ||
    pattern3.test(normalized) ||
    pattern4.test(normalized) ||
    pattern5.test(normalized) ||
    pattern6.test(normalized) ||
    pattern7.test(normalized) ||
    pattern8.test(normalized) ||
    pattern9.test(normalized) ||
    pattern0.test(normalized)
  );
};

export const isValidTelNumber = (value?: string): boolean => {
  if (!value) {
    return false;
  }

  if (!isCorrectPhoneNumber(value)) {
    return false;
  }

  if (forbiddenNumbers.includes(value)) {
    return false;
  }

  return isPossiblePhoneNumber(value) && isValidPhoneNumber(value);
};

export const isEmail = (email: string): boolean =>
  /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email);
